<template>
  <div class="index" v-cloak>
<!--    <div class="area-picker-container">
      <div class="area-picker" @click="show_street = true">
        <div>{{street_str}}</div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
    </div> -->
    <div class="news-list" v-if="articleList.length>0">
      <div class="news-item" v-for="i in articleList" @click="goDetail(i.id)">
        <div class="acea-row row-column row-between">
          <div class="news-title omit2">{{i.title}}</div>
          <div class="news-synopsis omit1">{{i.synopsis||'--'}}</div>
          <div class="news-time">{{i.add_time}}</div>
        </div>
        <div class="news-img">
          <img :src="i.image_input[0]" alt="">
        </div>
      </div>
    </div>
    <div class="nodata" v-else>
      --暂无内容--
    </div>

    <!-- 分页 -->
    <div class="page-content">
      <div class="iconfont icon-xiangzuo" @click="prePage"></div>
      <div class="page_number"><span style="color:#ff0000">{{ page }}</span><span style="margin:0 .2rem">/</span>{{
        page_count }}</div>
      <div class="iconfont icon-xiangyou" @click="nextPage"></div>
    </div>
    <!-- 底部占高 -->
    <div class="index-botom" style="height: 1rem"></div>
    <!-- 地区选择弹窗 -->
    <div class="mask" v-if="show_street" @click="show_street=!show_street"></div>
    <div class="area-window" v-if="show_street">
      <div class="window-btn">
        <div class="cancel-btn" @click="cancelWindow">取消</div>
        <div class="confirm-btn" @click="confirmChoose">确定</div>
      </div>
      <div class="area-container">
        <div class="street-list">
          <div 
            class="street-item" 
            :class="street_idx == k ?'active':''" 
            v-for="(i,k) in street_list"
            @click="chooseStreet(k)"
            >{{i.title}}</div>
        </div>
        <div class="comm-list">
          <div 
            class="comm-item" 
            :class="comm_idx == k ?'active':''" 
            v-for="(i,k) in comm_list"
            @click="chooseComm(k)"
            >{{i.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleList, getFulianCate } from "@api/public";

import cookie from "@utils/store/cookie";

export default {
  name: "CateList",
  components: {
  },
  props: {},
  data: function () {
    return {
      pid: 0, //分类id
      street_list: [], //街道列表
      comm_list:[],//社区列表
      street_idx:0, //街道下标
      comm_idx:0, //社区下标
      street_id:0, //街道id
      comm_id:0, //社区id
      street_str:'请选择您所在的街道社区',
      show_street:false,

      articleList:[],
      page:1,
      page_count:1,
      limit:10,
    };
  },
  watch: {
    comm_id(){
      this.getArticleList();
    },
  },
  mounted: function () {
    let that = this;
    that.pid = that.$route.query.pid;
    that.getArticleList();
    // that.getFulianCate();
  },
  methods: {
    getFulianCate: function () {
      let that = this;
      let pid = this.pid;
      getFulianCate(pid).then((res) => {
        let list = res.data;
        that.$set(that, "street_list", list);
        that.$set(that, "comm_list", list[0].children);

        // this.confirmChoose()
      });
    },

    chooseStreet(index){
      let list = this.street_list,
          choose_item = list[index];
      this.street_idx = index;

      this.comm_idx = 0;
      this.comm_list = choose_item.children;
    },
    chooseComm(index){
      let list = this.comm_list;
      this.comm_idx = index;
    },
    
    cancelWindow(){
      let street_list = this.street_list,
          street_id = this.street_id,
          comm_id = this.comm_id;
      for(let i in street_list){
        let item = street_list[i];
        console.log(item.id,street_id)
        if(item.id == street_id){
          let comm_list = item.children;
          this.comm_list = comm_list;
          this.street_idx = i;
          
          for(let j in comm_list){
            let comm = comm_list[j]
            if(comm.id == comm_id){
              this.comm_idx = j
              break
            }
          }
          break
        }
      }
      this.show_street = false
    },
    confirmChoose(){
      let street_list = this.street_list,
          comm_list = this.comm_list,
          street_idx = this.street_idx,
          comm_idx = this.comm_idx;
      this.street_id = street_list[street_idx].id;
      this.comm_id = comm_list[comm_idx].id;
      this.street_str = `${street_list[street_idx].title} ${comm_list[comm_idx].title}`;
      this.show_street = false
    },
    getArticleList:function(){
      let that = this;
      let q = {
        page: that.page,
        limit: that.limit
      };
      getArticleList(q, that.pid).then(res => {
        that.articleList = res.data.list;
        that.page_count = Math.ceil(res.data.count/that.limit);
      });
    },

    //上一页
    prePage:function(){
      let that = this;
      let page = that.page;
      page -= 1;
      page = page>=1?page:1;
      that.page = page;
      that.getArticleList();
    },
    nextPage:function(){
      let that = this;
      let page = that.page;
      let page_count = that.page_count;
      page += 1;
      page = page<=page_count?page:page_count;
      that.page = page;
      that.getArticleList();
    },
    goList: function (id) {
      this.$router.push({ path: "/news/list", query: { id: id } });
    },
    goDetail: function (id) {
      this.$router.push({ path: "/news_detail/" + id });
    },
  },
};
</script>
<style lang="scss" scoped>
.index {
  min-height: 100vh;
  background-color: #fceeef;
  padding: 10px;
}

.area-picker-container {
  padding: .4rem .2rem;
}

.area-picker {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1;
  padding: .2rem;
  border-radius: .1rem;

  .iconfont {
    font-size: .2rem;
    color: #bfbfbf;
  }
}

.news-list {
  background-color: #fff;
  padding: 0 .2rem;

  .news-item {
    display: flex;
    justify-content: space-between;
    padding: .3rem 0;

    &~.news-item {
      border-top: 1px solid #D2D2D2;
    }

    .news-title {
      font-size: .28rem;
    }

    .news-synopsis {
      font-size: .24rem;
      color: #B9BCBE;
    }

    .news-time {
      font-size: .22rem;
      color: #B9BCBE;
    }

    .news-img {
      flex-shrink: 0;
      margin-left: .2rem;
      img {
        width: 1.85rem;
        height: 1.43rem;
        vertical-align: bottom;
        object-fit: cover;
        border-radius: .1rem;
      }
    }
  }
}

.page-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .2rem 0;
  position: fixed;
  bottom: .5rem;
  width: 100%;
  left: 0;
}

.page-content .iconfont {
  font-size: .24rem;
  margin: 0 .4rem;
}

.area-window {
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 556;
  width: 100vw;
  height: 50%;

  .window-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .3rem;
    font-size: .3rem;
    line-height: 1;
    border-bottom: 1px solid #EFEFEF;
    font-size: .3rem;
    .cancel-btn {}

    .confirm-btn {
      color: #F64272;
    }
  }

  .area-container{
    height: calc(50vh - 0.9rem);
    display: flex;

    .street-list{
      min-width: 2.77rem;
      background-color: #EFEFEF;
      flex-shrink: 0;
      height: 100%;
      overflow-y: auto;
      .street-item{
        line-height: 1rem;
        text-align: center;
        font-size: .3rem;
        &.active{
          background-color: #fff;
          color: #F64272;
        }
      }
    }
    .comm-list{
      flex: 1;
      padding-left: .5rem;
      height: 100%;
      overflow-y: auto;
      .comm-item{
        padding: .25rem 0;
        font-size: .3rem;
        line-height: 1;
        &.active{
          color: #F64272;
        }
      }
    }
  }
}
.nodata{
  text-align: center;
  font-size: .24rem;
  margin-top: 2rem;
}
</style>
